import React from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
// import classNames from 'classnames';

import Modal from '@material-ui/core/Modal';
// import moment from 'moment';

import { maxWidth } from '../../helpers/media-queries';

import config from '../../data/config';

const styles = ({ palette, sizes }) => ({
  modal: {
    '& > div:first-child': {
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
    '& .lightbox-wrapper': {
      maxWidth: '1024px',
      width: '100%',
      height: '100%',
      margin: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      '& button': {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        margin: '0 10px ',
        '&:hover, &:active': {
          background: 'none',
        },
        '&.close-button': {
          position: 'absolute',
          top: sizes.baseSize + 'px',
          right: sizes.baseSize * 2 + 'px',
          width: '40px',
          height: '40px',
          margin: '0',
          '& img': {
            width: '100%',
            height: 'auto',
          },
          [maxWidth.md]: {
            top: '5px',
            right: '5px',
            width: '60px',
            height: '60px',
          },
        },
      },
      '& .lightbox-image': {
        width: '100%',
        height: 'auto',
        border: '5px solid white',
        [maxWidth.md]: {
          maxWidth: '75vw',
        },
      },
    },
  },
});

const mapper = (stores) => ({
  intl: stores.intl.dictionary,
  screenshot: stores.screenshots.screenshot,
  setScreenshot: (id) => stores.screenshots.setScreenshot(id),
  onClose: () => stores.screenshots.setScreenshot(0),
});

class Lightbox extends React.Component {
  // timestamp = moment().format('YYYYMMDDhh');

  render() {
    const {
      classes,
      onClose,
      screenshot: { aria = {}, ...screenshot },
      intl,
      ...props
    } = this.props;
    const timestamp = config.version ? config.version.replace(/\./gi, '') : '';
    return (
      <Modal className={classes.modal} onClose={onClose} {...props}>
        <div className="lightbox-wrapper">
          <button
            arial-label={intl['LOCALE.LIGHTBOX.CLOSE']}
            className="close-button"
            onClick={onClose}
          >
            <img
              src="./static/images/screenshot/close.png"
              alt={intl['LOCALE.LIGHTBOX.CLOSE']}
              title={intl['LOCALE.LIGHTBOX.CLOSE']}
            />
          </button>
          <button
            arial-label={intl['LOCALE.LIGHTBOX.BACK']}
            onClick={() => this._navigate(screenshot.id - 1)}
          >
            <img
              src="./static/images/screenshot/arrow-left.png"
              alt={intl['LOCALE.LIGHTBOX.BACK']}
              title={intl['LOCALE.LIGHTBOX.BACK']}
            />
          </button>
          <img
            src={`${screenshot.src}?${timestamp}`}
            alt={intl[aria.label]}
            title={intl[aria.label]}
            className="lightbox-image"
          />
          <button
            arial-label={intl['LOCALE.LIGHTBOX.NEXT']}
            onClick={() => this._navigate(screenshot.id + 1)}
          >
            <img
              src="./static/images/screenshot/arrow-right.png"
              alt={intl['LOCALE.LIGHTBOX.NEXT']}
              title={intl['LOCALE.LIGHTBOX.NEXT']}
            />
          </button>
        </div>
      </Modal>
    );
  }
  _navigate = (id) => {
    const { setScreenshot } = this.props;
    if (id < 1) id = 6;
    else if (id > 6) id = 1;
    setScreenshot(id);
  };
}

export default inject(mapper)(withStyles(styles)(Lightbox));
